import { Injectable } from '@angular/core';
import { State, Action, StateContext } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { tap } from 'rxjs/operators';
import { PostsService } from 'src/app/services/posts/posts.service';
import { BlogActions } from './blog.actions';

export interface Post {
  imagen?: string;
  titulo?: string;
  resumen?: string;
  contenido?: string;
  meta?: string;
  slug?: string;
}
export class BlogStateModel {
  public post!: Post;
  public postsList!: Post[];
  public postsCategories!: any[];
  public postPrincipal!: Post;
  public postsCarrousel!: Post[];
  public postLoaded!: boolean;
}
const defaults = {
  post: null,
  postsList: [],
  postsCategories: null,
  postPrincipal: null,
  postsCarrousel: [],
  postLoaded: false,
};
@State<BlogStateModel>({
  name: 'blog',
  defaults
})
@Injectable()
export class BlogState {
  constructor(
    private postsService: PostsService
  ) { }
  @Action(BlogActions.GetPost)
  getPost({ setState }: StateContext<BlogStateModel>,
    { postSlug }: BlogActions.GetPost) {
    setState(
      patch({
        postLoaded: false
      })
    )
    return this.postsService.verPost(postSlug)
      .pipe(
        tap(
          (postData) => {
            setState(
              patch({
                post: postData.post,
                postLoaded: true,
              })
            )
          },
          (error) => {
            console.error(error.error);
          }
        )
      )
  }
  @Action(BlogActions.GetPostPrincipal)
  getPostPrincipal({ setState }: StateContext<BlogStateModel>,
    { postSlug }: BlogActions.GetPostPrincipal) {
    setState(
      patch({
        postLoaded: false
      })
    )
    return this.postsService.verPost(postSlug)
      .pipe(
        tap(
          (postData) => {
            setState(
              patch({
                postPrincipal: postData.post,
                postLoaded: true
              })
            )
          },
          (error) => {
            console.error(error.error);
          }
        )
      )
  }
  @Action(BlogActions.GetPostList)
  getPostList({ getState,setState }: StateContext<BlogStateModel>, { categoriaSlug }: BlogActions.GetPostList) {
    return this.postsService.getPostList(categoriaSlug)
    .pipe(
      tap((data) => {
        setState(
          patch({
            postsList: data.posts
          })
        )
      },
      () => {})
    )
  }
  @Action(BlogActions.GetPostCategories)
  getCategories({ setState }: StateContext<BlogStateModel>) {
    return this.postsService.getPostCategories()
    .pipe(
      tap((categoriesData) => {
        setState(
          patch({
            postsCategories: categoriesData.categorias
          })
        )
      },
      () => {})
    )
  }
  @Action(BlogActions.ClearBlogState)
  clearBlogState({ setState }: StateContext<BlogStateModel>) {
    setState(
      patch({
        postsList: null,
        postsCategories: null,
      })
    )
  }
}
